var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('button',{staticClass:"btn btn-primary",class:_vm.additionalClasses,on:{"click":function($event){_vm.shownew=true}}},[_c('b-icon',{attrs:{"icon":"pencil-square"}}),_vm._v(" "+_vm._s(_vm.$t("new")))],1),_c('MenuModal',{attrs:{"show":_vm.shownew},on:{"close":function($event){_vm.shownew = false}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }